import { Duration, MarketCategoryType } from '@/types'
import type {
  MarketsHistoryTimeframeMap,
  MarketsHistoryFetchParamsMap
} from '@/types'

export const excludedPriceDeviationSlugs = [] as string[]

export const MARKET_CATEGORIES_TO_DISPLAY: MarketCategoryType[] = [
  MarketCategoryType.All,
  MarketCategoryType.Favorites,
  MarketCategoryType.Crypto,
  MarketCategoryType.Stocks,
  MarketCategoryType.Macro,
  MarketCategoryType.Meme
]

export const MIN_MARKETS_PER_CATEGORY = 5

export const MARKET_CATEGORY_FALLBACKS: Partial<
  Record<MarketCategoryType, MarketCategoryType>
> = {
  [MarketCategoryType.Meme]: MarketCategoryType.Crypto
}

const SECONDS_IN_AN_HOUR = 60 * 60
const SECONDS_IN_A_DAY = 24 * SECONDS_IN_AN_HOUR

export const MARKETS_HISTORY_FETCH_PARAMS: MarketsHistoryFetchParamsMap = {
  [Duration.OneDay]: { countback: 24, resolution: 60 },
  [Duration.OneWeek]: { countback: 42, resolution: 240 }
}

export const MARKETS_HISTORY_TIMEFRAMES: MarketsHistoryTimeframeMap = {
  [Duration.OneDay]: {
    lookbackSeconds: SECONDS_IN_A_DAY, // 1D
    fillIntervalSeconds: SECONDS_IN_AN_HOUR // 1H
  },
  [Duration.OneWeek]: {
    lookbackSeconds: 7 * SECONDS_IN_A_DAY, // 7D
    fillIntervalSeconds: 4 * SECONDS_IN_AN_HOUR // 4H
  }
}
